import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from 'store/authStore';
import AppLayout from 'layouts/AppLayout';
import LoginPage from 'pages/LoginPage';
import ResetPasswordPage from 'pages/ResetPasswordPage';
import ScenariosPage from 'pages/ScenariosPage';
import ScenarioPage from 'pages/ScenarioPage';
import DashboardPage from 'pages/DashboardPage';
import AdminPage from 'pages/AdminPage';
import ScenarioCreatePage from 'pages/ScenarioCreatePage';
import ScenarioEditPage from 'pages/ScenarioEditPage';
import DataSourcesPage from 'pages/DataSourcesPage';
import AgentPage from 'pages/AgentPage';

function PrivateRoute({ children }: { children: React.ReactElement }) {
  const user = useAuthStore((s) => s.user);
  return user ? children : <Navigate to="/login" replace />;
}

function AdminRoute({ children }: { children: React.ReactElement }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function DefaultRedirect() {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === 'admin' ? '/admin' : '/scenarios'} replace />;
}

export default function AppRouter() {
  const refreshUser = useAuthStore((s) => s.refreshUser);
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    if (user) refreshUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <AppLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<DefaultRedirect />} />
          <Route path="scenarios" element={<ScenariosPage />} />
          <Route
            path="scenarios/new"
            element={
              <AdminRoute>
                <ScenarioCreatePage />
              </AdminRoute>
            }
          />
          <Route
            path="scenarios/:id/edit"
            element={
              <AdminRoute>
                <ScenarioEditPage />
              </AdminRoute>
            }
          />
          <Route path="scenarios/:id" element={<ScenarioPage />} />
          <Route path="sources" element={<DataSourcesPage />} />
          <Route path="agent" element={<AgentPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route
            path="admin"
            element={
              <AdminRoute>
                <AdminPage />
              </AdminRoute>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
